import { companyRole } from '../company/company-role'
import { z } from 'zod'

export const invitation = z.object({
    role: companyRole,
    company: z.object({
        id: z.string(),
        name: z.string(),
    }),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
})

export type Invitation = z.infer<typeof invitation>

export const pendingInvitation = z.object({
    email: z.string(),
    role: companyRole,
    assignedCampaigns: z.object({ id: z.string(), title: z.string() }).array().default([]),
    createdAt: z.coerce.date(),
})

export type PendingInvitation = z.infer<typeof pendingInvitation>
